import { Component, Input } from '@angular/core';
import { PlIcon } from '@app/icon-library/icons';
import { ButtonType, IconColor } from '@shared/models/step.model';
import { IconBorderWidth, IconFrame } from '@app/icon-library/lib/pl-icon.component';
import { ButtonPadding, ButtonVariant } from '@app/components/button/button.component';
import { PdfGeneratorService } from '@shared/services/pdfGenerator/pdfGenerator.service';
import { PlRouter } from '@shared/services/pl-router.service';

export enum IconWidth {
  normal = 'h-36 w-36 min-w-[144px]',
  wider = 'h-36 w-48 min-w-[192px]',
}

@Component({
  selector: 'pl-icon-text',
  templateUrl: './iconText.component.html',
})
export class IconTextComponent {
  @Input({ required: true }) public icon!: PlIcon;
  @Input({ required: true }) public iconColor!: IconColor | null;
  @Input({ required: true }) public text!: string;
  @Input() public iconFrame: IconFrame = IconFrame.none;
  @Input() public iconWidth: IconWidth = IconWidth.normal;

  @Input() public buttonLabel: string = '';
  @Input() public buttonVariant: ButtonVariant = ButtonVariant.white;
  @Input() public buttonHref: string = '';
  @Input() public buttonType: ButtonType = ButtonType.link;

  public readonly IconBorderWidth: typeof IconBorderWidth = IconBorderWidth;
  public readonly IconColor: typeof IconColor = IconColor;
  public readonly PlIcon: typeof PlIcon = PlIcon;
  public readonly ButtonPadding: typeof ButtonPadding = ButtonPadding;

  constructor(
    private plRouter: PlRouter,
    private pdfGeneratorService: PdfGeneratorService,
  ) {}

  public onButtonClick(event: MouseEvent): void {
    switch (this.buttonType) {
      case ButtonType.link:
        window.open(this.buttonHref, '_blank');
        return;
      case ButtonType.state:
        this.plRouter.navigate([this.buttonHref], undefined, event);
        return;
      case ButtonType.pdf:
        this.pdfGeneratorService.generateAndDownloadPdf(this.buttonHref);
        return;
      default:
        throw new Error(`Unknown buttonType: ${this.buttonType}`);
    }
  }
}
